<template>
  <AdultPinCheck :success-fn="success">
    <div slot="title">
      <strong class="ch-adult-title">연령 제한 콘텐츠</strong>
      <p class="ch-adult-text01">
        이 정보 내용은 청소년 유해물로서<br>
        <strong>‘정보통신망 이용촉진 및 정보보호 등에 관한<br> 법률’</strong>
        및 ‘청소년 보호법’에 따라<br>19세 미만의 청소년이 이용할 수 없습니다
      </p>
    </div>
    <template v-slot:bottom_buttons="scopedValue">
      <BottomButtons :scopedValue="scopedValue"></BottomButtons>
    </template>
  </AdultPinCheck>
</template>
<script>
import AdultPinCheck from '@/views/adult/AdultPinCheck.vue'
import BottomButtons from '@/views/adult/ChildrenProtectionBottomButtons.vue'
import { get } from 'lodash'
import utils from '@/common/util/utils'
import { COOKIE_KEY_VERIFIED_ADULT, URL_COOKIE_DOMAIN } from '@/common/constant'
export default {
  name: 'AdultContentUnLock',
  components: {
    AdultPinCheck,
    BottomButtons
  },
  data () {
    return {
      referer: get(this.$route, 'query.referer', '')
    }
  },
  methods: {
    setCookie () {
      let expires = new Date()
      expires.setHours(expires.getHours() + 6)
      utils.cookies.setItem(COOKIE_KEY_VERIFIED_ADULT, '1', expires.toUTCString(), URL_COOKIE_DOMAIN, '/')
    },
    success () {
      this.setCookie()
      this.$router.replace(this.$route.params.enter)
    }
  }
}
</script>
